import { MarkupOptions } from 'utils/services/errorTrackingService/interfaces/MarkupOptions'

export const getMarkupOptions = <T extends object>(options: T): MarkupOptions => {
  const markupOptions: MarkupOptions = {
    scope: 'root',
    section: null,
  }
  if ('scope' in options) {
    markupOptions.scope = options.scope as MarkupOptions['scope']
  }

  if ('section' in options && 'scope' in options) {
    markupOptions.section = options.section as MarkupOptions['section']
  }

  return markupOptions
}
